import { Alert, Anchor } from "@mantine/core";
import { Link } from "react-router";
import { semanticColor } from "@how/design-system";
import { useWebsiteOffline } from "./offline-queries";
import type { WebsiteTab } from "./WebsiteTabs";

/**
 * On every Website screen, while the website is offline (ADR 0079): a line that says so, for the people who can put
 * it back (website.manage; the reader refuses others, and the banner then shows nothing). On the Settings screen
 * itself the card says the same, so the banner only names the screen from elsewhere.
 */
export function OfflineBanner({ active }: { readonly active: WebsiteTab }) {
  const state = useWebsiteOffline();
  if (state.data === undefined || !state.data.enabled) return null;
  return (
    <Alert
      color={semanticColor("warning")}
      variant="light"
      title="Your website is offline"
      mb="md"
      role="status"
      data-website-offline-banner
    >
      Visitors see your cover page, not your website.{" "}
      {active === "settings" ? (
        "Put it back below when you are ready."
      ) : (
        <>
          Put it back in{" "}
          <Anchor component={Link} to="/website/settings">
            Website settings
          </Anchor>
          .
        </>
      )}
    </Alert>
  );
}
